import { BookOpen, Home, Library, Settings, Sparkles } from "lucide-react";
import { Link, useLocation } from "@tanstack/react-router";
import { hapticSelection } from "@/lib/native-runtime";

const TABS = [
  { to: "/journal-home", label: "Journal", icon: Home },
  { to: "/journal", label: "Write", icon: Sparkles },
  { to: "/journals", label: "Library", icon: Library },
  { to: "/learn", label: "Learn", icon: BookOpen },
  { to: "/preferences", label: "Settings", icon: Settings },
] as const;

export function JournalNativeTabBar() {
  const { pathname } = useLocation();
  return (
    <nav aria-label="Journal app" className="fixed inset-x-0 bottom-0 z-[80] border-t border-border/70 bg-background/95 backdrop-blur-xl" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <ul className="mx-auto flex max-w-lg items-stretch px-2">
        {TABS.map((tab) => {
          const active = pathname === tab.to || (tab.to === "/journals" && pathname.includes("journal") && pathname !== "/journal" && pathname !== "/journal-home");
          const Icon = tab.icon;
          return (
            <li key={tab.to} className="flex-1">
              <Link to={tab.to} onClick={() => hapticSelection()} aria-current={active ? "page" : undefined} className={`flex min-h-[52px] flex-col items-center justify-center gap-1 py-1.5 text-[10px] font-medium transition-colors ${active ? "text-primary" : "text-muted-foreground"}`}>
                <Icon className="h-6 w-6" aria-hidden />
                <span>{tab.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}